import axios from "../../axios";

export async function fetchResourceHubFaqCategory(id) {
  return axios.get(`/resource_hub/faq/categories/` + id);
}

export async function fetchResourceHubFaqCategories(controller) {
  return axios({
    method: "get",
    url: "/resource_hub/faq/categories/",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createResourceHubFaqCategory(payload) {
  return axios
    .post(`/resource_hub/faq/categories/`, { category: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}
export async function updateResourceHubFaqCategory(payload) {
  return axios
    .put(`/resource_hub/faq/categories/${payload.id}`, { category: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function destroyResourceHubFaqCategory(payload) {
  return axios
    .delete(`/resource_hub/faq/categories/${payload.id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}
